import Request from '@/api/request';
import { SEND_LOG_URL } from '@/constants';

const api = new Request();

interface SendLogPayload {
  statementId?: string;
  addStatementId?: string;
  integration?: {
    url: string;
    status: string;
  };
  error?: string;
}

export async function sendLog(payload: SendLogPayload): Promise<void> {
  return api.post(SEND_LOG_URL, payload);
}
